import * as React from 'react'
import Link, { LinkProps } from 'next/link'
import { Button, ButtonProps } from '../Button'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'

const InnerButton: React.FC<
  {
    buttonText: string
    className?: string
    onClick?: React.MouseEventHandler<HTMLButtonElement>
    isLoading?: boolean
  } & ButtonProps
> = (props) => {
  const { buttonText, className, onClick, isLoading, ...rest } = props
  return (
    <Button
      onClick={onClick}
      className={classNames(className)}
      style={{
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 25,
        paddingRight: 25,
      }}
      {...rest}
    >
      {isLoading ? <FontAwesomeIcon icon={faSpinner} spin={true} /> : buttonText}
    </Button>
  )
}

export function CtaButton(
  props: {
    buttonText: string
    className?: string
    href?: LinkProps['href']
    isLoading?: boolean
  } & ButtonProps
) {
  const { buttonText, className, href, isLoading, ...rest } = props
  if (!href) {
    return <InnerButton buttonText={buttonText} className={className} isLoading={isLoading} {...rest} />
  }
  return (
    <Link href={href}>
      <a>
        <InnerButton buttonText={buttonText} className={className} isLoading={isLoading} {...rest} />
      </a>
    </Link>
  )
}
